import { Grid } from '@mui/material';
import React from 'react';
import HeaderTitle from './HeaderTitle';
import { TopHeaderProps } from './TopHeader';
import filterIcon from '../../../assets/image/filter.png';

function TopHeaderDesktop({ isTuneIcon, onClickTuneIcon }: TopHeaderProps) {
  return (
    <Grid container alignItems={'center'} style={{ marginTop: '10px' }}>
      <Grid item xs={4}>
        <HeaderTitle />
      </Grid>
      <Grid item xs={8} style={{ textAlign: 'right', cursor: 'pointer' }}>
        {isTuneIcon ? <img src={filterIcon} onClick={onClickTuneIcon} alt='filterIcon' /> : <></>}
      </Grid>
    </Grid>
  );
}

export default TopHeaderDesktop;
